export const defaultRestockPercent = 25;
